import sendRequest from "@ecom/ui/utils/sendRequestV2"
import getAdditionalData from "@ecom/ui/helpers/getAdditionalData"
import { APP_API_URL } from "../../helpers/api"

type VerifyMode = "sms" | "flashcall"

type Status = "pending" | "repeated" | "approve" | "reject" | "error"

export type SendToApiResponse = {
  requestId: string
  status: Status
  partnerExternalId?: number
}

export type SendToApiRequestProps = {
  data: Record<string, any>
  path: string
  apiId?: string
  parametr?: string | null
  verificationMode?: VerifyMode
}

export const sendToApi = ({ data, path, apiId }: SendToApiRequestProps) => {
  const additionalData = getAdditionalData()

  return sendRequest(
    `${APP_API_URL}${path}`,
    {
      ...data,
      additionalData,
    },
    apiId
  )
}
